enum PhoneNumberType {
    Home = 'Home',
    Mobile = 'Mobile',
}

export default PhoneNumberType;
